import { EXPERIMENT_IDENTIFIERS } from '~server/routes/Pricing/experimentsConfig';
import { usePricingExperiments } from '~shared/hooks/usePricingExperiments';
import { PricingTheme } from '~app/styles/pricing/types';
import { pricingElevation, packageColors, packageTheme } from '~app/styles/theme';
import { pricingPalette } from '~app/styles/pricing/colors';

import grow2792Theme from '~pricing/experiments/grow_2792_pnp_refresh_v1/theme';

export default function useTheme(): PricingTheme {
  const { priceExperiment } = usePricingExperiments();

  const pricingTheme: PricingTheme = {
    pricingElevation,
    pricingPalette, // User defined theme
    packageColors,
    packageTheme,
  };

  // GROW-2792 PnP Refresh
  if (priceExperiment.hasAssignment && priceExperiment.treatmentName === EXPERIMENT_IDENTIFIERS.GROW_2792.treatment) {
    return {
      ...pricingTheme,
      packageTheme: {
        ...packageTheme,
        ...grow2792Theme,
      },
    };
  }

  return pricingTheme;
}
